var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"modal__stripe",attrs:{"title":_vm.title,"show-close-button":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('stripe-card',{attrs:{"button-text":_vm.displayPrice},on:{"done":_vm.cb}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }